export var ChargeDiscountType = /*#__PURE__*/ function(ChargeDiscountType) {
    ChargeDiscountType["Percentage"] = "percentage";
    ChargeDiscountType["Currency"] = "currency";
    return ChargeDiscountType;
}({});
export var BillingScheduleType = /*#__PURE__*/ function(BillingScheduleType) {
    BillingScheduleType["BillNow"] = "bill_now";
    BillingScheduleType["ScheduleBill"] = "schedule_bill";
    return BillingScheduleType;
}({});
